import { graphql } from "gatsby";
import React from "react";
import SocialMediaRow from "../components/SocialMediaRow";

const SocialMediaRowParagraph = ({ content }) => {
  const sections = content.r?.field_social_media_row_content;

  return (
    <>
      <SocialMediaRow sections={sections} />
    </>
  );
};

export const query = graphql`
  fragment ParagraphSocialMediaRow on paragraph__social_media_row {
    __typename
    id
    r: relationships {
      field_social_media_row_content {
        id
        position: field_social_media_content_index
        source: field_social_media_content_sourc
        link: field_social_media_content_link {
          uri
          title
        }
        caption: field_social_media_content_capti {
          value
        }
        r: relationships {
          img: field_social_media_content_image {
            field_image {
              alt
            }
            r: relationships {
              field_image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(aspectRatio: 1, height: 600)
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default SocialMediaRowParagraph;
